import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center justify-center px-4 py-24 text-center">
      <span className="flex w-16 h-16 items-center justify-center rounded-lg bg-primary-500 text-background-50">
        <i className="ri-basketball-line text-3xl" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">页面不存在</h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面 <span className="font-mono text-foreground-700">{location.pathname}</span> 暂时不可用
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/live"
          className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-700 whitespace-nowrap transition-colors hover:bg-background-100"
        >
          <i className="ri-live-line" /> 前往直播赛事
        </Link>
      </div>
    </div>
  );
}